import script from "./TaskManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskManagement.vue?vue&type=script&setup=true&lang=js"

import "./TaskManagement.vue?vue&type=style&index=0&id=5ff4b119&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff4b119"]])

export default __exports__